<nz-layout class="app-import">
    <nz-content class="content">
        <nz-layout>
            <app-pdqiti21 />
            <app-pdqiti22 />
            <app-pdqv3 />
            <app-pdqm />
        </nz-layout>
    </nz-content>
</nz-layout>